import { render } from "./StarBrightSvg.vue?vue&type=template&id=045f901d"
import script from "./StarBrightSvg.vue?vue&type=script&lang=js"
export * from "./StarBrightSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__